// extracted by mini-css-extract-plugin
module.exports = {"container":"privacyPolicy_container__bnkTR"};